import { Grid, styled } from '@mui/material';
import React from 'react'

const KeyName = styled('div')(({ theme }) => ({
    fontSize: '16px',
    fontFamily: 'Satoshi-Light',
}));

const Answer = styled('div')(({ theme }) => ({
    fontSize: '16px',
    fontFamily: 'Satoshi-Bold',
}));

const ViewInventory = ({ activeTab, selectedItem }) => {
    return (
        <Grid container padding={"30px"} spacing={3} >
            {(activeTab?.value == 1 || activeTab?.value == 2 || activeTab?.value == 3 || activeTab?.value == 4) &&
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Company Name</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedItem?.companyName || "NA"}</Answer>
                    </Grid>
                </Grid>
            }
            {(activeTab?.value == 5 || activeTab?.value == 6) &&
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Item Name</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedItem?.itemName || "NA"}</Answer>
                    </Grid>
                </Grid>
            }
            <Grid container item xs={12}>
                <Grid item xs={3}>
                    <KeyName>Secondary Name</KeyName>
                </Grid>
                <Grid item xs={1} textAlign={"center"}>
                    <Answer>:</Answer>
                </Grid>
                <Grid item xs={8}>
                    <Answer>{selectedItem?.secondaryName || "NA"}</Answer>
                </Grid>
            </Grid>
            {(activeTab?.value == 1 || activeTab?.value == 5 || activeTab?.value == 6) &&
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Group</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedItem?.group || "NA"}</Answer>
                    </Grid>
                </Grid>
            }
            {(activeTab?.value == 1 || activeTab?.value == 6) &&
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Sub Group</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedItem?.subGroup || "NA"}</Answer>
                    </Grid>
                </Grid>
            }
            {(activeTab?.value == 1) &&
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Paper Certification</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedItem?.paperCertification || "NA"}</Answer>
                    </Grid>
                </Grid>
            }
            {activeTab?.value == 1 &&
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Color</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedItem?.color || "NA"}</Answer>
                    </Grid>
                </Grid>
            }
            {(activeTab?.value == 1 || activeTab?.value == 2 || activeTab?.value == 5) &&
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Size</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedItem?.size || "NA"}</Answer>
                    </Grid>
                </Grid>
            }
            {activeTab?.value == 1 &&
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Release Status</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{(selectedItem?.otherReleaseStatus ? selectedItem?.otherReleaseStatus : selectedItem?.releaseStatus) || "NA"}</Answer>
                    </Grid>
                </Grid>
            }
            {activeTab?.value == 2 &&
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Coating Preferences</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedItem?.coatingPreferences || "NA"}</Answer>
                    </Grid>
                </Grid>
            }
            {(activeTab?.value == 2 && selectedItem?.coatedType) &&
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Coated Type</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedItem?.coatedType || "NA"}</Answer>
                    </Grid>
                </Grid>
            }
            {activeTab?.value == 2 &&
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Actual Micron</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedItem?.micron || "NA"}</Answer>
                    </Grid>
                </Grid>
            }
            {activeTab?.value == 3 &&
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Chemical</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedItem?.chemicalName || "NA"}</Answer>
                    </Grid>
                </Grid>
            }
            {activeTab?.value == 3 &&
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Chemical Code</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedItem?.chemicalCode || "NA"}</Answer>
                    </Grid>
                </Grid>
            }
            {activeTab?.value == 3 &&
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Category</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedItem?.chemicalCategory || "NA"}</Answer>
                    </Grid>
                </Grid>
            }
            {activeTab?.value == 4 &&
                <Grid container item xs={12}>
                    <Grid item xs={3}>
                        <KeyName>Ink Name</KeyName>
                    </Grid>
                    <Grid item xs={1} textAlign={"center"}>
                        <Answer>:</Answer>
                    </Grid>
                    <Grid item xs={8}>
                        <Answer>{selectedItem?.inkName || "NA"}</Answer>
                    </Grid>
                </Grid>
            }
        </Grid>
    )
}

export default ViewInventory